const EOA_reports=[
    {
        'id':"6",
        "program":"EOA Report 2025-26",
        "pdf":"https://drive.google.com/file/d/1x9qoWzpUrqfkrTRxcP_HBUwT58eZxbJf/view?usp=drivesdk"
    },
    
    {
        'id':"5",
        "program":"EOA Report 2024-25",
        "pdf":"https://drive.google.com/file/d/1S4UTKKWvhpfkICe5lf5cofg9fLHXdxv0/view?usp=sharing"
    },
    {
        'id':"4",
        "program":"EOA Report 2023-24",
        "pdf":"https://drive.google.com/file/d/1j7kfr-vY-FCDqSxeNo4rgtglgcjSSGPP/view?usp=drive_link"
    },
    {
        'id':"3",
        "program":"EOA Report 2021-22",
        "pdf":"https://drive.google.com/file/d/1_fwyKkWpodkItUd5wooRlo2q9n9uyJ6R/view?usp=drive_link"
    },
    {
        'id':"2",
        "program":"EOA Report 2020-21",
        "pdf":"https://drive.google.com/file/d/1baKDxX_pbNChaEGgLVd564dNHdcDaNjw/view?usp=drive_link"
    },
    {
        'id':"1",
        "program":"EOA Report 2019-20",
        "pdf":"https://drive.google.com/file/d/1huB4-5q4AIhfyesPJ_ML-hzuE5vb8TL_/view?usp=drive_link"
    },
   
]

export {EOA_reports}